import primaryHeader from "./partials/primaryHeader";
import fnEventsSlider from "./partials/fnEventsSlider";
import fnQuotesSlider from "./partials/fnQuotesSlider";
import fnFaqs from "./partials/fnFaqs";
import fnAccordions from "./partials/fnAccordions";
import fnScrollHeader from "./partials/fnScrollHeader";
import fnLoadMoreEventsPaid from "./partials/fnLoadMoreEventsPaid";
import fnLoadMoreEventsCommunity from "./partials/fnLoadMoreEventsCommunity";
import fnLoadMoreOffersShop from "./partials/fnLoadMoreOffersShop";

export class Partials {
    constructor() {
        new primaryHeader();
        new fnEventsSlider();
        new fnQuotesSlider();
        new fnFaqs();
        new fnAccordions();
        new fnScrollHeader();
        new fnLoadMoreEventsPaid();
        new fnLoadMoreEventsCommunity();
        new fnLoadMoreOffersShop();
    }
}
